import React from "react"
import PageSpinStyled from "./PageSpinStyled"

const PageSpin = () => <PageSpinStyled size="large" />

export default PageSpin
